/**
 * Normaliza números telefónicos peruanos al formato internacional 519XXXXXXXX.
 */

export function normalizePhone(phone) {
  if (phone == null) return null;

  const trimmed = String(phone).trim();
  if (!trimmed) return null;

  let digits = trimmed.replace(/\D+/g, "");
  if (!digits) return null;

  while (digits.startsWith("5151")) {
    digits = digits.slice(2);
  }

  if (digits.length === 9 && digits.startsWith("9")) {
    digits = "51" + digits;
  }

  if (!/^519\d{8}$/.test(digits)) {
    return null;
  }

  return digits;
}

export function isValidPeruPhone(phone) {
  return normalizePhone(phone) !== null;
}

export function looksLikePhone(value) {
  const trimmed = String(value || "").trim();
  if (!trimmed || trimmed.includes("@")) return false;
  return /^[\d\s()+.\-]{8,20}$/.test(trimmed);
}

export function normalizeLoginIdentifier(identifier) {
  if (looksLikePhone(identifier)) {
    const normalized = normalizePhone(identifier);
    if (normalized) return normalized;
  }
  return String(identifier || "").trim();
}
